"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Textarea = exports.TextareaComponent = void 0;
var PropTypes = require("prop-types");
var React = require("react");
var ErrorMessage_1 = require("../ErrorMessage");
var HelpText_1 = require("../HelpText");
var InputLabel_1 = require("../InputLabel");
var _1 = require("./");
/**
 * Textarea
 */
var TextareaComponent = function (props) {
    // Extract known attributes from props into variables
    var addCount = props.addCount, className = props.className, // Capture the classname so it cannot be applied to the textarea
    children = props.children, errormessage = props.errormessage, forwardRef = props.forwardRef, helptext = props.helptext, id = props.id, isOptional = props.isOptional, isValid = props.isValid, label = props.label, maxCount = props.maxCount, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onFocus = props.onFocus, required = props.required, tooltipText = props.tooltipText, type = props.type, value = props.value, attributes = __rest(props, ["addCount", "className", "children", "errormessage", "forwardRef", "helptext", "id", "isOptional", "isValid", "label", "maxCount", "name", "onBlur", "onChange", "onFocus", "required", "tooltipText", "type", "value"]) // tslint:disable-line
    ;
    attributes.id = id;
    attributes.className = 'form-control';
    attributes.name = name ? name : id;
    var _a = React.useState(0), charCount = _a[0], setCharCount = _a[1];
    var labelProps = {
        id: id,
        isOptional: isOptional,
        label: label,
        tooltipText: tooltipText,
    };
    if (typeof onBlur === 'function') {
        attributes.onBlur = onBlur;
    }
    if (addCount) {
        attributes.onChange = function (e) {
            setCharCount(e.target.value.length);
        };
        attributes.defaultValue = value;
    }
    else if (typeof onChange === 'function') {
        attributes.value = value;
        attributes.onChange = function (e) {
            // @ts-ignore
            onChange(attributes.name, e.target.value, e);
        };
    }
    else {
        attributes.defaultValue = value;
    }
    if (typeof onFocus === 'function') {
        attributes.onFocus = onFocus;
    }
    if (typeof required === 'boolean' && required === true) {
        attributes['aria-required'] = true;
    }
    if (maxCount) {
        attributes.maxLength = maxCount;
    }
    var ErrorMessageComponent;
    var HelpTextComponent;
    var TextareaCounterComponent;
    if (typeof isValid === 'boolean' && isValid === false) {
        // Invalid
        attributes.className += ' is-invalid';
        attributes['aria-invalid'] = true;
        // Invalid with error message
        if (errormessage) {
            attributes['aria-describedby'] = id + "-errormessage";
            ErrorMessageComponent = (React.createElement(ErrorMessage_1.ErrorMessage, { id: id, message: errormessage }));
        }
    }
    else if (helptext) {
        attributes['aria-describedby'] = id + "-helptext";
        HelpTextComponent = (React.createElement(HelpText_1.HelpText, { id: id }, helptext));
    }
    if (addCount) {
        var maxdefault = 2000;
        if (!maxCount) {
            attributes.maxLength = maxdefault;
        }
        TextareaCounterComponent = (React.createElement(_1.TextareaCounter, { id: id, maxCount: maxCount ? maxCount : maxdefault, count: charCount }));
    }
    return (React.createElement("div", { className: "form-group" },
        React.createElement(InputLabel_1.InputLabel, __assign({}, labelProps)),
        React.createElement("textarea", __assign({}, attributes, { ref: forwardRef })),
        TextareaCounterComponent,
        HelpTextComponent,
        ErrorMessageComponent));
};
exports.TextareaComponent = TextareaComponent;
exports.TextareaComponent.defaultProps = {
    isValid: true,
};
exports.TextareaComponent.displayName = 'Textarea';
// tslint:disable no-string-literal
exports.TextareaComponent['propTypes'] = {
    addCount: PropTypes.bool,
    errormessage: PropTypes.string,
    helptext: PropTypes.any,
    id: PropTypes.string.isRequired,
    isOptional: PropTypes.bool,
    isValid: PropTypes.bool,
    label: PropTypes.string.isRequired,
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    placeholder: PropTypes.string,
    required: PropTypes.bool,
    rows: PropTypes.number,
    tooltipText: PropTypes.string,
    value: PropTypes.string.isRequired,
};
// tslint:enable no-string-literal
exports.Textarea = React.forwardRef(function (props, ref) {
    return (React.createElement(exports.TextareaComponent, __assign({}, props, { forwardRef: ref })));
});
exports.Textarea.displayName = 'Textarea';
